import {ref, Ref} from '@vue/composition-api';
export class EditorSplitPanelsControllerClass {
	private static _instance: EditorSplitPanelsControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorSplitPanelsControllerClass());
	}

	private constructor() {}

	private _dragInProgress!: Ref<boolean>;
	private _windowResizeInProgress!: Ref<boolean>;
	private _timeout: number | undefined;
	init() {
		this._dragInProgress = ref(false);
		this._windowResizeInProgress = ref(false);

		window.addEventListener('resize', this.onResize.bind(this));
	}

	onResize() {
		this._windowResizeInProgress.value = true;
		if (this._timeout) {
			clearTimeout(this._timeout);
		}
		this._timeout = setTimeout(() => {
			this._windowResizeInProgress.value = false;
		}, 1000) as any /* the build fails if we use the node type NodeJs.Timeout */;
	}

	// getters
	dragInprogress() {
		return this._dragInProgress.value;
	}
	windowResizeInProgress() {
		return this._windowResizeInProgress.value;
	}

	// mutations
	setDragInProgress(state: boolean): void {
		this._dragInProgress.value = state;
	}
}

export const SplitPanels = EditorSplitPanelsControllerClass.instance();
